module.exports = __webpack_public_path__ + "img/010-reaper.c9549223.png";